module.exports = __webpack_public_path__ + "img/coastCleanUp_041022_B.cb3ef3e8.jpg";